module.exports = __webpack_public_path__ + "_/assets/images/icons/icon-envelope-1d589c9abbcd6889f0ca6bf865ad1564.svg";